import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Dashboard from '../views/Dashboard.vue'
import AdminList from '../views/Users/AdminList.vue'
import AddAdmin from '../views/Users/AddAdmin.vue'
import UserList from '../views/Users/List.vue'
import UserNew from '../views/Users/Add.vue'
import UserEdit from '../views/Users/Edit.vue'
import CityList from '../views/Cities/List.vue'
import CityAdd from '../views/Cities/Add.vue'
import CityEdit from '../views/Cities/Edit.vue'
import IndustryList from '../views/Industries/List.vue'
import IndustryAdd from '../views/Industries/Add.vue'
import IndustryEdit from '../views/Industries/Edit.vue'
import CompanyList from '../views/Companies/List.vue'
import CompanyAdd from '../views/Companies/Add.vue'
import CompanyEdit from '../views/Companies/Edit.vue'
import CompanyCreditRecordList from '../views/CompanyCreditRecord/List.vue'
import CompanyCreditRecordAdd from '../views/CompanyCreditRecord/Add.vue'
import CompanyCreditRecordEdit from '../views/CompanyCreditRecord/Edit.vue'
import CompanyCreditRecordDetail from '../views/CompanyCreditRecord/Detail.vue'
import GuaranteedBadRecordList from '../views/GuaranteedBadRecord/List.vue'
import GuaranteedBadRecordAdd from '../views/GuaranteedBadRecord/Add.vue'
import GuaranteedBadRecordEdit from '../views/GuaranteedBadRecord/Edit.vue'
import ExpertList from '../views/Experts/List.vue'
import ExpertAdd from '../views/Experts/Add.vue'
import ExpertEdit from '../views/Experts/Edit.vue'
import ProjectList from '../views/Projects/List.vue'
import ProjectAdd from '../views/Projects/Add.vue'
import ProjectEdit from '../views/Projects/Edit.vue'
import ProjectDetail from '../views/Projects/Detail.vue'
import PermissionList from '../views/Permissions/List.vue'
import PermissionAdd from '../views/Permissions/Add.vue'
import PermissionEdit from '../views/Permissions/Edit.vue'
import RoleList from '../views/Roles/List.vue'
import RoleAdd from '../views/Roles/Add.vue'
import RoleEdit from '../views/Roles/Edit.vue'
import RolePermission from '../views/Roles/RolePermission.vue'
import GuarantorList from '../views/Guarantors/List.vue'
import GuarantorListIndustrial from '../views/Guarantors/ListIndustrial.vue'
import GuarantorListRegional from '../views/Guarantors/ListRegional.vue'
import GuarantorAdd from '../views/Guarantors/Add.vue'
import GuarantorEdit from '../views/Guarantors/Edit.vue'
import GuarantorMyDetail from '../views/Guarantors/MyDetail.vue'
import GuarantorMyPreview from '../views/Guarantors/MyPreview.vue'
import GuarantorDetail from '../views/Guarantors/Detail.vue'
import GuarantorPreview from '../views/Guarantors/Preview.vue'
import FileRequirementList from '../views/Guarantors/FileRequirementList.vue'
import AddFileRequirement from '../views/Guarantors/AddFileRequirement.vue'
import EditFileRequirement from '../views/Guarantors/EditFileRequirement.vue'
import SupervisorList from '../views/Supervisors/List.vue'
import SupervisorAdd from '../views/Supervisors/Add.vue'
import SupervisorEdit from '../views/Supervisors/Edit.vue'
import SupervisorDetail from '../views/Supervisors/Detail.vue'
import GuaTemplateList from '../views/GuaTemplates/List.vue'
import GuaTemplateAdd from '../views/GuaTemplates/Add.vue'
import GuaTemplateEdit from '../views/GuaTemplates/Edit.vue'
import GuaTemplateDetail from '../views/GuaTemplates/Detail.vue'
import GuaranteeList from '../views/Guarantees/List.vue'
import GuaranteeAdd from '../views/Guarantees/Add.vue'
import GuaranteeAddStep1 from '../views/Guarantees/AddStep1.vue'
import GuaranteeAddStep2 from '../views/Guarantees/AddStep2.vue'
import GuaranteeAddStep3 from '../views/Guarantees/AddStep3.vue'
import GuaranteeAddStep4 from '../views/Guarantees/AddStep4.vue'
import GuaranteeAddStep5 from '../views/Guarantees/AddStep5.vue'
import GuaranteeDetail from '../views/Guarantees/Detail.vue'
import GuaranteeVerify from '../views/Guarantees/Verify.vue'
import VerifyPdf from '../views/Guarantees/VerifyPdf.vue'
import GuaranteeVarietyList from '../views/GuaranteeVarieties/List.vue'
import GuaranteeVarietyAdd from '../views/GuaranteeVarieties/Add.vue'
import GuaranteeVarietyEdit from '../views/GuaranteeVarieties/Edit.vue'
import GuaranteeClaimList from '../views/Claims/List.vue'
import AddGuaranteeClaim from '../views/Claims/Add.vue'
import EditGuaranteeClaim from '../views/Claims/Edit.vue'
import GuaranteeClaimDetail from '../views/Claims/Detail.vue'
import ReceiptList from '../views/Receipts/List.vue'
import ReceiptDetail from '../views/Receipts/Detail.vue'
import ReceiptAdd from '../views/Receipts/Add.vue'
import ReceiptAddStep1 from '../views/Receipts/AddStep1.vue'
import ReceiptAddStep2 from '../views/Receipts/AddStep2.vue'
import ReceiptAddStep3 from '../views/Receipts/AddStep3.vue'
import ReceiptAddStep4 from '../views/Receipts/AddStep4.vue'
import ReceiptAddStep5 from '../views/Receipts/AddStep5.vue'
import ProjectRegisterList from '../views/ProjectRegisters/List.vue'
import ProjectRegisterAdd from '../views/ProjectRegisters/Add.vue'
import ProjectRegisterAddByContractor from '../views/ProjectRegisters/AddByContractor.vue'
import ProjectRegisterEditByContractor from '../views/ProjectRegisters/EditByContractor.vue'
import ProjectRegisterEdit from '../views/ProjectRegisters/Edit.vue'
import ProjectRegisterDetail from '../views/ProjectRegisters/Detail.vue'
import AnnouncementList from '../views/Announcements/List.vue'
import AnnouncementAdd from '../views/Announcements/Add.vue'
import AnnouncementEdit from '../views/Announcements/Edit.vue'
import AnnouncementDetail from '../views/Announcements/Detail.vue'
import StatisticOverall from '../views/Statistics/Overall.vue'
import Login from '../views/Login.vue'
import Login_Center2 from '../views/Login_Center2.vue'
import Register from '../views/Register.vue'
import GuarantorListPublished from '../views/Guarantors/ListPublished.vue'
import GuarantorAppraisalQuestionList from '../views/GuarantorAppraise/ListQuestion.vue'
import GuarantorAppraisalQuestionAdd from '../views/GuarantorAppraise/AddQuestion.vue'
import GuarantorAppraisalQuestionEdit from '../views/GuarantorAppraise/EditQuestion.vue'
import GuarantorAppraisalSectionList from '../views/GuarantorAppraise/ListSection.vue'
import GuarantorAppraisalSectionAdd from '../views/GuarantorAppraise/AddSection.vue'
import GuarantorAppraisalSectionEdit from '../views/GuarantorAppraise/EditSection.vue'
import GuarantorAppraisalPaperList from '../views/GuarantorAppraise/ListPaper.vue'
import GuarantorAppraisalPaperAdd from '../views/GuarantorAppraise/AddPaper.vue'
import GuarantorAppraisalPaperEdit from '../views/GuarantorAppraise/EditPaper.vue'
import GuarantorAppraiseViewPaper from '../views/GuarantorAppraise/PreviewPaper.vue'
import GuarantorAppraisalRecordList from '../views/GuarantorAppraise/ListRecord.vue'
import GuarantorAppraiseSelfAppraisal from '../views/GuarantorAppraise/SelfAppraisal.vue'
import GuarantorAppraiseRecordView from '../views/GuarantorAppraise/ViewRecord.vue'
import GuarantorAppraiseAuditAppraisal from '../views/GuarantorAppraise/AuditAppraisal.vue'
import KVSList from '../views/KVS/List.vue'
import KVSAdd from '../views/KVS/Add.vue'
import KVSEdit from '../views/KVS/Edit.vue'
import HtmlEditor from '../views/Editor.vue'
import Welcome from '../views/Welcome.vue'
import Loading from '../views/Loading.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/loading',
    children: [
      {
        path: '/dashboard',
        alias: '/my',
        name: 'Dashboard',
        component: Dashboard,
        meta: { 
          keepAlive: true,
          tagName: '我的'
        }
      },
      {
        path: '/admins/list',
        name: 'admin-list',
        component: AdminList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '后台用户列表'
        }
      },
      {
        path: '/admins/new',
        name: 'admin-new',
        component: AddAdmin,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增后台用户'
        }
      },
      {
        path: '/users/list',
        name: 'user-list',
        component: UserList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '用户管理'
        }
      },
      {
        path: '/users/new',
        name: 'user-new',
        component: UserNew,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增用户'
        }
      },
      {
        path: '/users/edit',
        name: 'user-edit',
        component: UserEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改用户'
        }
      },
      {
        path: '/cities/list',
        name: 'city-list',
        component: CityList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '城市管理'
        }
      },
      {
        path: '/cities/new',
        name: 'city-new',
        component: CityAdd,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增城市'
        }
      },
      {
        path: '/cities/edit',
        name: 'city-edit',
        component: CityEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改城市'
        }
      },
      {
        path: '/industries/list',
        name: 'industry-list',
        component: IndustryList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '行业领域管理'
        }
      },
      {
        path: '/industries/new',
        name: 'industry-new',
        component: IndustryAdd,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增行业领域'
        }
      },
      {
        path: '/industries/edit',
        name: 'industry-edit',
        component: IndustryEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改行业领域'
        }
      },
      {
        path: '/companies/list',
        name: 'company-list',
        component: CompanyList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '企业管理'
        }
      },
      {
        path: '/companies/new',
        name: 'company-new',
        component: CompanyAdd,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增企业'
        }
      },
      {
        path: '/companies/edit',
        name: 'company-edit',
        component: CompanyEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改企业'
        }
      },
      {
        path: '/company-credit-record/list',
        name: 'company-credit-record-list',
        component: CompanyCreditRecordList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '企业信用记录管理'
        }
      },
      {
        path: '/company-credit-record/new',
        name: 'company-credit-record-new',
        component: CompanyCreditRecordAdd,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增企业信用'
        }
      },
      {
        path: '/company-credit-record/detail/:companyCreditRecordId',
        name: 'company-credit-record-detail',
        component: CompanyCreditRecordDetail,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '企业信用记录详情'
        }
      },
      {
        path: '/company-credit-record/edit/:companyCreditRecordId',
        name: 'company-credit-record-edit',
        component: CompanyCreditRecordEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改企业信用'
        }
      },
      {
        path: '/guaranteed-bad-record/list',
        name: 'guaranteed-bad-record-list',
        component: GuaranteedBadRecordList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '投保人不良行为'
        }
      },
      {
        path: '/guaranteed-bad-record/new',
        name: 'guaranteed-bad-record-new',
        component: GuaranteedBadRecordAdd,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增不良行为'
        }
      },
      {
        path: '/guaranteed-bad-record/edit/:id',
        name: 'guaranteed-bad-record-edit',
        component: GuaranteedBadRecordEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改不良行为'
        }
      },
      {
        path: '/experts/list',
        name: 'expert-list',
        component: ExpertList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '专业技术人员管理'
        }
      },
      {
        path: '/experts/new',
        name: 'expert-new',
        component: ExpertAdd,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增专业技术人员'
        }
      },
      {
        path: '/experts/edit',
        name: 'expert-edit',
        component: ExpertEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改专业技术人员'
        }
      },
      {
        path: '/projects/list',
        name: 'project-list',
        component: ProjectList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '项目管理'
        }
      },
      {
        path: '/projects/new',
        name: 'project-new',
        component: ProjectAdd,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增项目'
        }
      },
      {
        path: '/projects/detail/:projectId',
        name: 'project-detail',
        component: ProjectDetail,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '项目详情'
        }
      },
      {
        path: '/projects/edit',
        name: 'project-edit',
        component: ProjectEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改项目'
        }
      },
      {
        path: '/permissions/list',
        name: 'permission-list',
        component: PermissionList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '基础权限管理'
        }
      },
      {
        path: '/permissions/new',
        name: 'permission-new',
        component: PermissionAdd,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增基础权限'
        }
      },
      {
        path: '/permissions/edit',
        name: 'permission-edit',
        component: PermissionEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改基础权限'
        }
      },
      {
        path: '/roles/list',
        name: 'role-list',
        component: RoleList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '角色管理'
        }
      },
      {
        path: '/roles/new',
        name: 'role-new',
        component: RoleAdd,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增角色'
        }
      },
      {
        path: '/roles/edit',
        name: 'role-edit',
        component: RoleEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改角色'
        }
      },
      {
        path: '/roles/permissions',
        name: 'role-basic-permissions',
        component: RolePermission,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '设置角色权限'
        }
      },
      {
        path: '/guarantors/list',
        name: 'guarantor-list',
        component: GuarantorList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '保证人管理'
        }
      },
      {
        path: '/guarantors/listindustrial',
        name: 'guarantor-industrial-list',
        component: GuarantorListIndustrial,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '行业保证人管理'
        }
      },
      {
        path: '/guarantors/listregional',
        name: 'guarantor-regional-list',
        component: GuarantorListRegional,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '区域保证人管理'
        }
      },
      {
        path: '/guarantors/new',
        name: 'guarantor-new',
        component: GuarantorAdd,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增保证人'
        }
      },
      {
        path: '/guarantors/edit/:guarantorId',
        name: 'guarantor-edit',
        component: GuarantorEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改保证人'
        }
        // children: [
        //   {
        //     path: '/guarantors/edit/:guarantorId/step1',
        //     name: 'guarantor-step1',
        //     component: () => import('../views/Guarantors/Step1.vue'),
        //     meta: {
        //       newTag: false,
        //       keepAlive: false,
        //       tagName: '机构备案-步骤一'
        //     }
        //   },
        //   {
        //     path: '/guarantors/edit/:guarantorId/step2',
        //     name: 'guarantor-step1',
        //     component: () => import('../views/Guarantors/Step2.vue'),
        //     meta: {
        //       newTag: false,
        //       keepAlive: false,
        //       tagName: '机构备案-步骤二'
        //     }
        //   }
        // ]
      },
      {
        path: '/guarantors/mydetail',
        name: 'my-guarantor-detail',
        component: GuarantorMyDetail,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '保证人详情'
        }
      },
      {
        path: '/guarantors/preview',
        name: 'preview-form',
        component: GuarantorMyPreview,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '打印备案表'
        }
      },
      {
        path: '/guarantors/detail/:guarantorId',
        name: 'guarantor-detail',
        component: GuarantorDetail,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '保证人详情'
        }
      },
      {
        path: '/guarantors/detail/:guarantorId/preview',
        name: 'preview-form',
        component: GuarantorPreview,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '打印备案表'
        }
      },
      {
        path: '/guarantors/detail/:guarantorId/filerequirements',
        name: 'file-requirement-list',
        component: FileRequirementList,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '资料清单设置'
        }
      },
      {
        path: '/guarantors/detail/:guarantorId/filerequirements/Add',
        name: 'file-requirement-new',
        component: AddFileRequirement,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '新增资料清单'
        }
      },
      {
        path: '/guarantors/detail/:guarantorId/filerequirements/Edit/:tid',
        name: 'file-requirement-edit',
        component: EditFileRequirement,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改资料清单'
        }
      },
      {
        path: '/supervisors/list',
        name: 'supervisor-list',
        component: SupervisorList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '监管人管理'
        }
      },
      {
        path: '/supervisors/new',
        name: 'supervisor-new',
        component: SupervisorAdd,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增监管人'
        }
      },
      {
        path: '/supervisors/edit/:supervisorId',
        name: 'supervisor-edit',
        component: SupervisorEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改监管人'
        }
      },
      {
        path: '/supervisors/detail/:supervisorId',
        name: 'supervisor-detail',
        component: SupervisorDetail,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '监管人详情'
        }
      },
      {
        path: '/templates/list',
        name: 'template-list',
        component: GuaTemplateList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '保函模板管理'
        }
      },
      {
        path: '/templates/new',
        name: 'template-new',
        component: GuaTemplateAdd,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增保函模板'
        }
      },
      {
        path: '/templates/edit/:templateId',
        name: 'template-edit',
        component: GuaTemplateEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改保函模板'
        }
      },
      {
        path: '/templates/detail/:templateId',
        name: 'template-detail',
        component: GuaTemplateDetail,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '保函模板详情'
        }
      },
      {
        path: '/guarantees/list',
        name: 'guarantee-list',
        component: GuaranteeList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '保函管理'
        }
      },
      {
        path: '/guarantees/new',
        name: 'guarantee-new',
        redirect: '/guarantees/new/step1',
        component: GuaranteeAdd,
        meta: {
          keepAlive: true,
          maxView: true,
          tagName: '新增保函'
        },
        children: [
          {
            path: '/guarantees/new/step1',
            name: 'guarantee-new',
            component: GuaranteeAddStep1,
            meta: {
              newTag: false,
              keepAlive: false,
              maxView: true,
              tagName: '选择区域-新增保函'
            }
          },
          {
            path: '/guarantees/new/step2',
            name: 'guarantee-new',
            component: GuaranteeAddStep2,
            meta: {
              newTag: false,
              keepAlive: false,
              maxView: true,
              tagName: '选择行业-新增保函'
            }
          },
          {
            path: '/guarantees/new/step3',
            name: 'guarantee-new',
            component: GuaranteeAddStep3,
            meta: {
              newTag: false,
              keepAlive: false,
              maxView: true,
              tagName: '项目信息-新增保函'
            }
          },
          {
            path: '/guarantees/new/step4',
            name: 'guarantee-new',
            component: GuaranteeAddStep4,
            meta: {
              newTag: false,
              keepAlive: false,
              maxView: true,
              tagName: '保函信息-新增保函'
            }
          },
          {
            path: '/guarantees/new/step5',
            name: 'guarantee-new',
            component: GuaranteeAddStep5,
            meta: {
              newTag: false,
              keepAlive: false,
              maxView: true,
              tagName: '保函提交-新增保函'
            }
          }
        ]
      },
      {
        path: '/guarantees/new/:orderNumber',
        name: 'guarantee-new',
        component: GuaranteeAdd,
        meta: {
          keepAlive: false,
          maxView: true,
          tagName: '修改保函'
        }
      },
      {
        path: '/guarantees/detail/:orderNumber',
        name: 'guarantee-detail',
        component: GuaranteeDetail,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '保函详情'
        }
      },
      {
        path: '/guarantees/verify',
        name: 'verify',
        component: GuaranteeVerify,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '保函验真'
        }
      },
      {
        path: '/guarantees/verifypdf',
        name: 'verify-pdf',
        component: VerifyPdf,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '电子保函验证'
        }
      },
      {
        path: '/claims/list',
        name: 'claim-list',
        component: GuaranteeClaimList,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '代偿列表'
        }
      },
      {
        path: '/claims/add/:orderNumber',
        name: 'claim-add',
        component: AddGuaranteeClaim,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '新增代偿'
        }
      },
      {
        path: '/claims/edit/:id/:orderNumber',
        name: 'claim-edit',
        component: EditGuaranteeClaim,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改代偿'
        }
      },
      {
        path: '/claims/detail/:id/',
        name: 'claim-detail',
        component: GuaranteeClaimDetail,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '代偿详情'
        }
      },
      {
        path: '/gua-types/list',
        name: 'guarantee-variety-list',
        component: GuaranteeVarietyList,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '担保种类管理'
        }
      },
      {
        path: '/gua-types/add',
        name: 'variety-new',
        component: GuaranteeVarietyAdd,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '新增担保种类'
        }
      },
      {
        path: '/gua-types/edit',
        name: 'variety-edit',
        component: GuaranteeVarietyEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改担保种类'
        }
      },
      {
        path: '/receipts/list',
        name: 'receipt-list',
        component: ReceiptList,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '保证金列表'
        }
      },
      {
        path: '/receipts/detail/:orderNumber',
        name: 'receipt-detail',
        component: ReceiptDetail,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '保证金详情'
        }
      },
      {
        path: '/receipts/new',
        name: 'receipt-new',
        redirect: '/receipts/new/step1',
        component: ReceiptAdd,
        meta: {
          keepAlive: true,
          maxView: true,
          tagName: '新增保证金'
        },
        children: [
          {
            path: '/receipts/new/step1',
            name: 'receipt-new',
            component: ReceiptAddStep1,
            meta: {
              newTag: false,
              keepAlive: false,
              maxView: true,
              tagName: '选择区域-新增保证金'
            }
          },
          {
            path: '/receipts/new/step2',
            name: 'receipt-new',
            component: ReceiptAddStep2,
            meta: {
              newTag: false,
              keepAlive: false,
              maxView: true,
              tagName: '选择行业-新增保证金'
            }
          },
          {
            path: '/receipts/new/step3',
            name: 'receipt-new',
            component: ReceiptAddStep3,
            meta: {
              newTag: false,
              keepAlive: false,
              maxView: true,
              tagName: '项目信息-新增保证金'
            }
          },
          {
            path: '/receipts/new/step4',
            name: 'receipt-new',
            component: ReceiptAddStep4,
            meta: {
              newTag: false,
              keepAlive: false,
              maxView: true,
              tagName: '保证金信息-新增保证金'
            }
          },
          {
            path: '/receipts/new/step5',
            name: 'receipt-new',
            component: ReceiptAddStep5,
            meta: {
              newTag: false,
              keepAlive: false,
              maxView: true,
              tagName: '提交'
            }
          }
        ]
      },
      {
        path: '/receipts/new/:orderNumber',
        name: 'receipt-new',
        component: ReceiptAdd,
        meta: {
          keepAlive: false,
          maxView: true,
          tagName: '修改保证金'
        }
      },
      {
        path: '/project-register/list',
        name: 'project-register-list',
        component: ProjectRegisterList,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '通知书列表'
        }
      },
      {
        path: '/project-register/add',
        name: 'project-register-add',
        component: ProjectRegisterAdd,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增通知书'
        }
      },
      {
        path: '/project-register/addbycontractor',
        name: 'project-register-add-by-contractor',
        component: ProjectRegisterAddByContractor,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '新增通知书'
        }
      },
      {
        path: '/project-register/editbycontractor/:orderNumber',
        name: 'project-register-edit-by-contractor',
        component: ProjectRegisterEditByContractor,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '修改通知书'
        }
      },
      {
        path: '/project-register/edit/:orderNumber',
        name: 'project-register-edit',
        component: ProjectRegisterEdit,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '修改通知书'
        }
      },
      {
        path: '/project-register/detail/:orderNumber',
        name: 'project-register-detail',
        component: ProjectRegisterDetail,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '通知书详情'
        }
      },
      {
        path: '/announcements/list',
        name: 'announcement-list',
        component: AnnouncementList,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '公告列表'
        }
      },
      {
        path: '/announcements/add',
        name: 'announcement-add',
        component: AnnouncementAdd,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '新增公告'
        }
      },
      {
        path: '/announcements/edit/:id',
        name: 'announcement-edit',
        component: AnnouncementEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改公告'
        }
      },
      {
        path: '/announcements/detail/:id',
        name: 'announcement-detail',
        component: AnnouncementDetail,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '公告详情'
        }
      },
      {
        path: '/statistics/overall',
        name: 'Statistics',
        component: StatisticOverall,
        meta: { 
          keepAlive: true,
          maxView: true,
          tagName: '统计中心'
        }
      },
      {
        path: '/kvs/list',
        name: 'kvs-list',
        component: KVSList,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '配置列表'
        }
      },
      {
        path: '/kvs/add',
        name: 'kvs-add',
        component: KVSAdd,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '新增配置'
        }
      },
      {
        path: '/kvs/edit',
        name: 'kvs-edit',
        component: KVSEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '编辑配置'
        }
      },
      {
        path: '/guarantor-appraisal/list-question',
        name: 'guarantor-appraisal-list-question',
        component: GuarantorAppraisalQuestionList,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '评价表题目管理'
        }
      },
      {
        path: '/guarantor-appraisal/new-question',
        name: 'guarantor-appraisal-new-question',
        component: GuarantorAppraisalQuestionAdd,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '新增题目'
        }
      },
      {
        path: '/guarantor-appraisal/edit-question/:id',
        name: 'guarantor-appraisal-edit-question',
        component: GuarantorAppraisalQuestionEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改题目'
        }
      },
      {
        path: '/guarantor-appraisal/list-section',
        name: 'guarantor-appraisal-list-section',
        component: GuarantorAppraisalSectionList,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '评价表大题管理'
        }
      },
      {
        path: '/guarantor-appraisal/new-section',
        name: 'guarantor-appraisal-new-section',
        component: GuarantorAppraisalSectionAdd,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '新增大题'
        }
      },
      {
        path: '/guarantor-appraisal/edit-section/:id',
        name: 'guarantor-appraisal-edit-section',
        component: GuarantorAppraisalSectionEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改大题'
        }
      },
      {
        path: '/guarantor-appraisal/list-paper',
        name: 'guarantor-appraisal-list-paper',
        component: GuarantorAppraisalPaperList,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '评价表试卷管理'
        }
      },
      {
        path: '/guarantor-appraisal/new-paper',
        name: 'guarantor-appraisal-new-paper',
        component: GuarantorAppraisalPaperAdd,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '新增试卷'
        }
      },
      {
        path: '/guarantor-appraisal/edit-paper/:id',
        name: 'guarantor-appraisal-edit-paper',
        component: GuarantorAppraisalPaperEdit,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '修改试卷'
        }
      },
      {
        path: '/guarantor-appraisal/view-paper/:paperId',
        name: 'guarantor-appraisal-view-paper',
        component: GuarantorAppraiseViewPaper,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '预览试卷'
        }
      },
      {
        path: '/guarantor-appraisal/list-record',
        name: 'guarantor-appraisal-list-record',
        component: GuarantorAppraisalRecordList,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '评价历史'
        }
      },
      {
        path: '/guarantor-appraisal/self/:recordId',
        name: 'guarantor-appraisal-self',
        component: GuarantorAppraiseSelfAppraisal,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '填报评价表'
        }
      },
      {
        path: '/guarantor-appraisal/record/:recordId',
        name: 'guarantor-appraisal-record',
        component: GuarantorAppraiseRecordView,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '查看评价表'
        }
      },
      {
        path: '/guarantor-appraisal/audit/:recordId',
        name: 'guarantor-appraisal-audit',
        component: GuarantorAppraiseAuditAppraisal,
        meta: { 
          keepAlive: false,
          maxView: true,
          tagName: '审核评价表'
        }
      },
    ]
  },
  {
    path: '/loading',
    name: 'loading',
    component: Loading
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: Welcome
  },
  {
    path: '/welcome/:region',
    name: 'Welcome',
    component: Welcome
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/login2',
    name: 'Login2',
    component: Login_Center2
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/verify',
    name: 'verify',
    component: GuaranteeVerify,
    meta: { 
      keepAlive: false,
      tagName: '保函验真'
    }
  },
  {
    path: '/published',
    name: 'GuarantorPublishedList',
    component: GuarantorListPublished,
    meta: { 
      keepAlive: false,
      tagName: '保证人名单公示'
    }
  },
  {
    path: '/published/detail/:guarantorId',
    name: 'GuarantorPublishedDetail',
    component: GuarantorDetail,
    meta: { 
      keepAlive: false,
      tagName: '保证人详情'
    }
  },
  {
    path: '/editor',
    name: 'HtmlEditor',
    component: HtmlEditor,
    meta: { 
      keepAlive: false,
      tagName: '编辑器'
    }
  },
]

const router = new VueRouter({
  routes
})

export default router
